import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useKeycloak } from '../KeycloakContext';

const SharedDriveLayout = () => {
  const { keycloak } = useKeycloak();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!keycloak || keycloak.authenticated) {
      return;
    }

    const fullPath = `${location.pathname}${location.search}`;
    const probePendingKey = `kc-probe-pending:${fullPath}`;

    if (sessionStorage.getItem(probePendingKey) === '1') {
      sessionStorage.removeItem(probePendingKey);
      return;
    }

    sessionStorage.setItem(probePendingKey, '1');
    navigate(
      `/login?mode=probe&returnTo=${encodeURIComponent(
        fullPath
      )}&fallbackTo=${encodeURIComponent(fullPath)}`,
      { replace: true }
    );
  }, [keycloak, location.pathname, location.search, navigate]);

  return <Outlet />;
};

export default SharedDriveLayout;
